if (document.querySelector('.tabs-sec__tabs-container')) {
  const tabsContainersArr = document.querySelectorAll(
    '.tabs-sec__tabs-container'
  );
  tabsContainersArr.forEach((tabsContainer) => {
    if (!tabsContainer.classList.contains('is-init')) {
      tabsContainer.classList.add('is-init');

      const togglesDeskArr = tabsContainer.querySelectorAll(
        '.tabs-sec__toggles .tabs-sec__toggle'
      );
      const togglesMobArr = tabsContainer.querySelectorAll(
        '.tabs-sec__container .tabs-sec__toggle'
      );
      const contentsArr = tabsContainer.querySelectorAll('.tabs-sec__content');

      togglesDeskArr.forEach((toggleDesk, idx) => {
        toggleDesk.addEventListener('click', () => {
          openTabFunc(toggleDesk, togglesMobArr[idx], contentsArr[idx]);
        });
      });

      togglesMobArr.forEach((toggleMob, idx) => {
        toggleMob.addEventListener('click', () => {
          openTabFunc(togglesDeskArr[idx], toggleMob, contentsArr[idx]);
        });

        if (idx === 0) {
          toggleMob.click();
        }
      });

      function openTabFunc(toggleDesk, toggleMob, content) {
        for (let i = 0; i < togglesDeskArr.length; i++) {
          togglesDeskArr[i].classList.remove('is-active');
          togglesMobArr[i].classList.remove('is-active');
          contentsArr[i].classList.remove('is-active');
        }

        toggleDesk.classList.add('is-active');
        toggleMob.classList.add('is-active');
        content.classList.add('is-active');

        reinitBgChangeAnimation();
        AOS.refreshHard();
      }

      function closeTabFunc(toggleDesk, toggleMob, content) {
        toggleDesk.classList.remove('is-active');
        toggleMob.classList.remove('is-active');
        content.classList.remove('is-active');
      }
    }
  });
}
